import * as React from 'react';
import { ButtonModifier } from '../../../../infrastructure/helpers';
import DefaultButton, { ButtonProp } from '../../default-button/default-button';
import { createCloseSubWindowButton, ISubWindowButtonProps } from '../create-sub-window-buttons';
import { CloseXIcon } from '../../icons/icons';

/**
 * Default sub-window close button presentation. Use DefaultButton component.
 * @param props
 * @constructor
 */
const DefaultCloseSubWindowPresentation = (props: Partial<ButtonProp> & ISubWindowButtonProps) => {
    const propsWithDefaults = {
        modifier: ['cancel', 'fat'] as ButtonModifier[],
        text: 'Cancel',
        ...props,
    };

    return <DefaultButton {...propsWithDefaults} />;
};

const DefaultCloseSubWindowButton = createCloseSubWindowButton<Partial<ButtonProp>>(DefaultCloseSubWindowPresentation);

/**
 * Sub window cross `X` icon, closing the sub-window.
 */
const CrossCloseSubWindowIcon = createCloseSubWindowButton<React.HTMLAttributes<HTMLSpanElement>>(CloseXIcon);

export { DefaultCloseSubWindowButton, CrossCloseSubWindowIcon };

